import React, { useEffect } from 'react';

export default function AboutUs() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.2 });

    const items = document.querySelectorAll('.about-fade');
    items.forEach((item, idx) => {
      item.style.transitionDelay = `${idx * 0.15}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      padding: '8rem 6%',
      backgroundColor: '#E4D4C3', // cream
      color: '#1F110B', // charcoal
    },
    container: {
      maxWidth: '1000px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr)',
      gap: '4rem',
    },
    contentWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '4rem',
      alignItems: 'center',
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.85rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#A63C1E', // mahogany
      marginBottom: '1rem',
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
      lineHeight: 1.1,
      marginBottom: '2rem',
    },
    body: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1.05rem',
      lineHeight: 1.8,
      color: '#2B1509', // espresso
      marginBottom: '1.5rem',
    },
    statGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2rem',
      marginTop: '3rem',
    },
    statNum: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '3rem',
      color: '#D96D29', // sun orange
      lineHeight: 1,
      marginBottom: '0.5rem',
    },
    statLabel: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.9rem',
      fontWeight: 500,
      textTransform: 'uppercase',
      color: '#8B4224', // terra
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .about-content { grid-template-columns: 1fr !important; }
        }
      `}</style>
      <section id="about" style={s.section}>
        <div style={s.container}>
          
          <div className="about-content" style={s.contentWrapper}>
            <div className="about-fade preFade">
              <div style={s.subtitle}>Est. 2021</div>
              <h2 style={s.title}>Rooted in African Soil</h2>
              <p style={s.body}>
                Savanna Sips was founded on a simple principle: to bring the vibrant, 
                sun-drenched flavors of Kenyan coffee directly to the global market 
                without compromising on ethics or quality.
              </p>
              <p style={s.body}>
                What started as a close relationship with a single farming cooperative 
                has grown into a dedicated operation supplying high-grade wholesale 
                beans and roasted coffee across the United States. We oversee every 
                step—from the volcanic slopes under the equatorial sun, through the 
                meticulous washing and drying, to the final export ship.
              </p>
            </div>

            <div className="about-fade preFade">
              <div style={s.statGrid}>
                <div>
                  <div style={s.statNum}>100%</div>
                  <div style={s.statLabel}>Kenyan Origin</div>
                </div>
                <div>
                  <div style={s.statNum}>2M+</div>
                  <div style={s.statLabel}>Lbs Exported</div>
                </div>
                <div>
                  <div style={s.statNum}>40+</div>
                  <div style={s.statLabel}>Partner Farms</div>
                </div>
                <div>
                  <div style={s.statNum}>3</div>
                  <div style={s.statLabel}>Generations of Roasting</div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
    </>
  );
}
